export class verification {
  // 是否身份证号码
  public static identityId = /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/;
  // 是否手机号码或者固话
  public static telephone = /^[1][0-9]{10}$/;
  // 是否邮箱
  public static mailbox = /^([a-zA-Z0-9]+[-_\.]?)+@[a-zA-Z0-9]+\.[a-z]+$/;
  // 整数填写
  public static integer = /^-?[1-9]\d*$/;
  // 正整数填写
  public static positiveInteger = /^[1-9]\d*$/;
  // 11或者12位的数字
  public static commonMobile = /^(\d{11}|\d{12})$/;
  // 小写字母
  public static lowercaseLetters = /^[a-z]+$/;
  // 大写字母
  public static capital = /^[A-Z]+$/;
  // 大小写字母混合
  public static caseMixing = /^[A-Za-z]+$/;
  // 数字加字母 (不包含特殊化符合) 1111@1111
  public static emoveSpecialSymbols = /^[a-zA-Z0-9]+$/;
  // 校验输入是否为中文
  public static chinese = /^[\u0391-\uFFE5A-Za-z]+$/;
  // 校验密码输入可以指定某些特殊字符;@%&#
  public static haveSpecialStr = /^[@%&#a-zA-Z0-9]+$/;
  // 新密码。
  public static passSpecialStr = /^(?![a-zA-Z]+$)(?![A-Z0-9]+$)(?![A-Z\W_!@#$%^&*`~()-+=]+$)(?![a-z0-9]+$)(?![a-z\W_!@#$%^&*`~()-+=]+$)(?![0-9\W_!@#$%^&*`~()-+=]+$)[a-zA-Z0-9\W_!@#$%^&*`~()-+=]{8,16}$/;
  // 判断所有不存在的集合
  public static checkUrl = /http(s)?:\/\/([\w-]+\.)+[\w-]+(\/[\w- .\/?%&=]*)?/;
  //判断是否是html结尾
  public static html = /^((?!(\(|\)|<|>))\S)*?(\.html|\.m3u8)$/;

  public static chinaLicensePlateRegex = /^[京津沪渝冀豫云辽黑湘皖鲁新苏浙赣鄂桂甘晋蒙陕吉闽贵粤青藏川宁琼]{1}[A-Z]{1}[a-zA-Z_0-9]{5,6}$/;


  public static chinaDriverLicenseNumberRegex = /^[A-Z0-9]{12}$/;

  public static vinRegex = /^[A-HJ-NPR-Z0-9]{17}$/;
  
  public static engineNumberRegex = /^[A-Z0-9]{6,}$/;

  /**
   * 检测关键字高亮
   * @param content
   * @param keyWords <string | array>
   * @param color
   * @returns
   */
  public static detectionKeyword(
    content: string,
    keyWords: any,
    color: string
  ) {
    let str = content;
    if (typeof keyWords == "string") {
      // 字符串模式
      if (!keyWords) return content;
      str = content.replace(
        new RegExp(keyWords, "g"),
        `<span style="color:${color};">${keyWords}</span>`
      );
    } else {
      // 数组模式
      if (content && content !== "") {
        // 2.定制关键词对应正则
        keyWords.forEach((e: string, i: number) => {
          const regStr = e;
          const reg = new RegExp(regStr, "g");
          // 3.正则替换，关键词飘红
          str = str.replace(
            reg,
            `<span style="color:${color};">` + e + "</span>"
          );
        });
      }
    }
    return str;
  }
  /**
   *
   * @param rule
   * @param value
   * @param callback
   */
  public static validatePassword(
    rule: any,
    value: any,
    callback: (arg0: Error | undefined) => void
  ) {
    let reg = /(?!^(\d+|[a-zA-Z]+|[~!@#$%^&*?]+)$)^[\w~!@#$%^&*?]{6,12}$/;
    if (!reg.test(value)) {
      callback(new Error("密码应是6-12位数字、字母或字符！"));
    } else {
      callback(undefined);
    }
  }
}
